import React from 'react'

import { GlobalStyles, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'
import ReactJoyride from 'react-joyride'

import { useJoyride } from './JoyrideProvider'

export const Joyride: React.FC = () => {
  const { run, steps, stepIndex, handleJoyrideCallback } = useJoyride()
  const { palette, spacing } = useTheme()
  const { t } = useTranslation()

  const locale = {
    back: t('tour.back', 'Back'),
    last: t('tour.last', 'Finish'),
    next: t('tour.next', 'Next'),
    nextLabelWithProgress: t('tour.nextLabelWithProgress', 'Next (Step {step} of {steps})'),
    skip: t('tour.skip', 'Skip'),
  }

  return (
    <>
      <GlobalStyles
        styles={{
          // body: run
          //   ? {
          //       overflow: 'hidden !important',
          //       touchAction: 'none !important',
          //     }
          //   : {},
          // html: run
          //   ? {
          //       overflow: 'hidden !important',
          //       touchAction: 'none !important',
          //     }
          //   : {},
          '.react-joyride__tooltip': {
            fontSize: '14px !important',
            maxWidth: '350px !important',
            borderRadius: '12px !important',
          },
          '.__floater__arrow': {
            display: 'none !important',
          },
        }}
      />

      <ReactJoyride
        steps={steps}
        stepIndex={stepIndex}
        run={run}
        hideCloseButton
        callback={handleJoyrideCallback}
        continuous
        showProgress
        showSkipButton
        disableScrollParentFix
        disableOverlayClose
        scrollToFirstStep
        scrollOffset={50}
        locale={locale}
        spotlightPadding={7}
        styles={{
          spotlightLegacy: {
            borderRadius: `${spacing(1)} !important`,
          },
          tooltipContent: {
            color: palette.text.primary,
            fontSize: '11px !important',
            maxWidth: '350px !important',
            borderRadius: '12px !important',
          },
          options: {
            backgroundColor: palette.background.default,
            zIndex: 10000,
          },
          buttonNext: {
            height: '35px',
            fontFamily: 'Wix Madefor Text',
            fontWeight: 600,
            letterSpacing: 0.4,
            backgroundColor: palette.secondary.main,
            outline: 'none',
            color: palette.blue[600],
            padding: '6px 12px',
            fontSize: '14px',
          },
          buttonBack: {
            height: '35px',
            fontFamily: 'Wix Madefor Text',
            fontWeight: 600,
            letterSpacing: 0.4,
            color: palette.blue[600],
            fontSize: '14px',
          },
          buttonSkip: {
            height: '35px',
            fontFamily: 'Wix Madefor Text',
            fontWeight: 600,
            letterSpacing: 0.4,
            color: palette.text.secondary,
          },
        }}
      />
    </>
  )
}
